/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MarqCommonProtocolFileResponse,
  MonitoringEnforcementTPProtocolsExcelExportByListingIdRequest,
  MonitoringEnforcementTPProtocolsExcelExportRequest,
  MonitoringEnforcementTPProtocolsExcelExportResponse,
  MonitoringEnforcementTPProtocolsGetEnforcementTPListingsRequest,
  MonitoringEnforcementTPProtocolsGetEnforcementTPListingsResponse,
  MonitoringEnforcementTPProtocolsGetExportListingsRequest,
  MonitoringEnforcementTPProtocolsGetTpProgressFilterRequest,
  MonitoringEnforcementTPProtocolsGetTpReportRequest,
  MonitoringEnforcementTPProtocolsGetTpReportResponse,
  MonitoringFilterProtocolResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class MonitoringEnforcementTp<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags MonitoringEnforcementTP
   * @name EnforcementTpProgressFilterCreate
   * @request POST:/monitoring/enforcement/tp/progress_filter
   */
  enforcementTpProgressFilterCreate = (
    data: MonitoringEnforcementTPProtocolsGetTpProgressFilterRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/monitoring/enforcement/tp/progress_filter`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringEnforcementTP
   * @name EnforcementTpGetReviewListCreate
   * @request POST:/monitoring/enforcement/tp/get_review_list
   */
  enforcementTpGetReviewListCreate = (
    data: MonitoringEnforcementTPProtocolsGetEnforcementTPListingsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringEnforcementTPProtocolsGetEnforcementTPListingsResponse, any>({
      path: `/monitoring/enforcement/tp/get_review_list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringEnforcementTP
   * @name EnforcementTpTpReportCreate
   * @request POST:/monitoring/enforcement/tp/tp_report
   */
  enforcementTpTpReportCreate = (
    data: MonitoringEnforcementTPProtocolsGetTpReportRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringEnforcementTPProtocolsGetTpReportResponse, any>({
      path: `/monitoring/enforcement/tp/tp_report`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringEnforcementTP
   * @name EnforcementTpExcelExportCreate
   * @request POST:/monitoring/enforcement/tp/excel/export
   */
  enforcementTpExcelExportCreate = (
    data: MonitoringEnforcementTPProtocolsExcelExportRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringEnforcementTPProtocolsExcelExportResponse, any>({
      path: `/monitoring/enforcement/tp/excel/export`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringEnforcementTP
   * @name EnforcementTpGetExportListCreate
   * @request POST:/monitoring/enforcement/tp/get_export_list
   */
  enforcementTpGetExportListCreate = (
    data: MonitoringEnforcementTPProtocolsGetExportListingsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/monitoring/enforcement/tp/get_export_list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringEnforcementTP
   * @name EnforcementTpExcelExportListingIdCreate
   * @request POST:/monitoring/enforcement/tp/excel/export/listing-id
   */
  enforcementTpExcelExportListingIdCreate = (
    data: MonitoringEnforcementTPProtocolsExcelExportByListingIdRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/monitoring/enforcement/tp/excel/export/listing-id`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
